import { render } from "./FullWidthVideo.vue?vue&type=template&id=1183b604"
import script from "./FullWidthVideo.vue?vue&type=script&lang=js"
export * from "./FullWidthVideo.vue?vue&type=script&lang=js"
script.render = render

export default script